const MAX_EDGE = 1920;
const JPEG_QUALITY = 0.82;

/** Shrink a large photo. JPG stays JPG and PNG stays PNG. */
export async function compressImage(
  file: Blob
): Promise<{ data: ArrayBuffer; contentType: string; filename: string }> {
  const png = isPng(file);
  const bitmap = await createImageBitmap(file);
  try {
    let { width, height } = bitmap;
    const scale = Math.min(1, MAX_EDGE / Math.max(width, height));
    width = Math.max(1, Math.round(width * scale));
    height = Math.max(1, Math.round(height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('This phone could not prepare the photo');
    ctx.drawImage(bitmap, 0, 0, width, height);
    const type = png ? 'image/png' : 'image/jpeg';
    const blob = await canvasToBlob(canvas, type, png ? undefined : JPEG_QUALITY);
    if (!blob) throw new Error('This phone could not prepare the photo');
    const original = file instanceof File ? file.name : '';
    const base = original.replace(/\.[^.]+$/, '') || 'photo';
    const ext = png ? 'png' : original.toLowerCase().endsWith('.jpeg') ? 'jpeg' : 'jpg';
    return {
      data: await blob.arrayBuffer(),
      contentType: type,
      filename: `${base}.${ext}`,
    };
  } finally {
    bitmap.close();
  }
}

function isPng(file: Blob): boolean {
  const name = file instanceof File ? file.name.toLowerCase() : '';
  return file.type === 'image/png' || name.endsWith('.png');
}

function canvasToBlob(
  canvas: HTMLCanvasElement,
  type: string,
  quality: number | undefined
): Promise<Blob | null> {
  return new Promise((resolve) => canvas.toBlob(resolve, type, quality));
}
